<template>
    <el-button 
        :type="type" 
        :disabled="disabled || loading || loaded"
        :class="['loading-button', {loading : loading, loaded: loaded, small: small}]"
        @click="$emit('click')"
        :style="colorStyle">
        <slot >Submit</slot>
        <span v-if="loading" 
            class="cover-icon button loading-icon"
            :style="colorStyle">
            <LoadSpinnerIcon ></LoadSpinnerIcon>
        </span>
        <span v-else-if="loaded" class="cover-icon loaded-icon">
            <i class="el-icon-check"></i>
        </span>
    </el-button>
</template>

<script>
import LoadSpinnerIcon from './icon/LoadSpinner'

export default {
    name: 'loading-button',

    props: {
        type: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        loading: {
            type: Boolean
        },
        loaded: {
            type: Boolean
        },
        colorRange: {
            type: Array
        },
        small: {
            type: Boolean
        }
    },

    computed: {
        colorStyle() {
            return this.colorRange && Array.isArray(this.colorRange) ? `background: linear-gradient(to top right, ${this.colorRange[0]}, ${this.colorRange[1]} )` : ''
        }
    },

    components: {
        LoadSpinnerIcon
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
.el-button.loading-button {
    position: relative;
    .cover-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    }
    &.small .cover-icon {
        padding-top: 7px;
        padding-bottom: 7px;
        border-radius: 14px;
    }
    .loading-icon {
        background-color: inherit;
    }
    .loaded-icon {
        background-color: $success-color;
        color: #ffffff;
        &>i {
            font-size: 22px;
            font-weight: bold;
        }
    }
    &.loading.is-disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
    &.loaded {
        border: 1px solid $success-color;
    }
}
</style>

<style scoped>
.el-button >>> >span {
    background-color: inherit;
}
</style>